import { render, staticRenderFns } from "./SigSelect.vue?vue&type=template&id=bb3772d6"
import script from "./SigSelect.vue?vue&type=script&lang=ts"
export * from "./SigSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports